import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SocialComponent } from '../Core/components/Social/social.component';
import { SocialActivateGuard } from './guards/social-activate.guard';
import { ThemeManagementComponent } from '../Intelligence/components/ThemeManagement/theme-management.component';
import { ThemeComponent } from '../Intelligence/components/Theme/theme.component';
import { ThemeAnalyticsComponent } from '../Intelligence/components/ThemeAnalytics/theme-analytics.component';
import { ThemePostFeedComponent } from '../Intelligence/components/ThemePostFeed/theme-post-feed.component';
import { FilterResolver } from '../../Common/Basic/service/filter.resolver';

const socialRoutes: Routes = [
    {
        path: 'Social',
        component: SocialComponent,
        canActivate: [SocialActivateGuard],
        children: [
            {
                path: 'themes',
                children: [
                    {
                        path: '',
                        component: ThemeManagementComponent,
                        data: { title: 'Social.themes.browserTitle' },
                    },
                    {
                        path: 'theme/:theme_id',
                        data: { title: 'Social.themes.browserTitle' },
                        component: ThemeComponent,
                        resolve: { filters: FilterResolver },
                        children: [
                            {
                                path: 'analytics',
                                component: ThemeAnalyticsComponent
                            },
                            {
                                path: 'postFeed',
                                component: ThemePostFeedComponent
                            },
                            {
                                path: '',
                                redirectTo: 'analytics',
                                pathMatch: 'full'
                            },
                            {
                                path: '**',
                                component: ThemeAnalyticsComponent
                            }
                        ]
                    }
                ]
            },
            {
                path: 'archive',
                data: { title: 'Social.themes.browserTitle' },
                children: [
                    {
                        path: 'results',
                        data: { title: 'Social.themes.browserTitle' },
                        component: ThemeComponent,
                        resolve: { filters: FilterResolver },
                        children: [
                            {
                                path: 'analytics',
                                component: ThemeAnalyticsComponent,
                                data: { title: 'Social.themes.browserTitle' }
                            },
                            {
                                path: 'postFeed',
                                component: ThemePostFeedComponent,
                                data: { title: 'Social.themes.browserTitle' }
                            },

                        ]
                    },
                    {
                        path: '**',
                        component: ThemeManagementComponent,
                        data: { title: 'Social.themes.browserTitle' }
                    }
                ]
            },

            {
                path: '**',
                component: ThemeManagementComponent,
                data: {title: 'Social.themes.browserTitle'}
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(socialRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        SocialActivateGuard,
        FilterResolver,
    ]
})
export class SocialRoutingModule { }
